import * as types from "./../types";
import MasterData from "./../../services/MasterData.Service";
import CardDetails from "./../../services/CardDetails.Service";
import {
  funcUpdateAppStateAfterResponse,
  // funcSetBootAppFlag,
} from "./AppStateActions";
import Dbfunctions from "../../PouchDb/Pouchdb";
import EncrDecrService from "../../services/EncrDecrService.Service";

const initState = {
  isSaved: true,
  currentAction: "",
  isSubmited: false,
  isSubmitedSuccess: false,
  screenName: "",
  loading: false,
  error: null,
};
let payload = {};
let errorState = {};
export const funcFetchMasterData = (cardTypeData) => async (dispatch) => {
  var response;
  if(window.isPouchDBAvailable){
  var res = await Dbfunctions.GetState(types.LOCAL_MASTER_SET);

  if (res._rev) {
    response = res?.response;
  }
  else if(res.error) {
    var responseServ = await MasterData.funcGetEapplyData(cardTypeData);
    response = JSON.parse(JSON.stringify(responseServ));
    if(response?.data?.statusCode === "000"
      && response.data?.data?.eapplyMasterDataRsType?.designationList?.length > 0
      && response.data?.data?.eapplyMasterDataRsType?.companyList?.length > 0 && window.isPouchDBAvailable)

      Dbfunctions.CreateState({
        _id: types.LOCAL_MASTER_SET,
        response,
      });
  } 
  } else {
    var responseServ = await MasterData.funcGetEapplyData(cardTypeData);
    response = JSON.parse(JSON.stringify(responseServ));
    if(response?.data?.statusCode === "000"
      && response.data?.data?.eapplyMasterDataRsType?.designationList?.length > 0
      && response.data?.data?.eapplyMasterDataRsType?.companyList?.length > 0 && window.isPouchDBAvailable)

      Dbfunctions.CreateState({
        _id: types.LOCAL_MASTER_SET,
        response,
      });
  }

  // if (response && response.data) {
  //   if (response.data.statusCode === "000") {
  //     dispatch({
  //       type: types.GET_MASTER_DATA,
  //       payload: response.data.data,
  //     });
  //   } else {
  //     dispatch({
  //       type: types.GET_MASTER_DATA,
  //       payload: response?.data?.data,
  //     });
  //   }
  // } else {
  //   dispatch({
  //     type: types.GET_MASTER_DATA,
  //     payload: response?.data?.data,
  //   });
  // }
  dispatch({
    type: types.GET_MASTER_DATA,
    payload: response?.data?.data,
  });
  dispatch(funcUpdateAppStateAfterResponse(payload, errorState));
  return response?.data?.statusCode;
};
export const funcPartnerThemeData = () => async (dispatch) => {   
  let partnerThemeData;
  let resTheme;   
  if(window.isPouchDBAvailable){
    resTheme = await Dbfunctions.GetState(types.LOCAL_PARTNER_THEME_DATA) ;
    
    if (resTheme._rev) {
        partnerThemeData = resTheme?.partnerThemeData; 
    } else if (resTheme.error) {
        const responsePartner = await fetch(process.env.PUBLIC_URL + `/themeConfig.json`);
        partnerThemeData = await responsePartner.json();
        if(window.isPouchDBAvailable)
        await Dbfunctions.CreateState({ _id: types.LOCAL_PARTNER_THEME_DATA, partnerThemeData });
    } 
  }
    else {
        const responsePartner = await fetch(process.env.PUBLIC_URL + `/themeConfig.json`);
        partnerThemeData = await responsePartner.json();
        if(window.isPouchDBAvailable)
        await Dbfunctions.CreateState({ _id: types.LOCAL_PARTNER_THEME_DATA, partnerThemeData });
    }
    dispatch({
      type: types.APP_THEME_DATA,
      payload: partnerThemeData,
    });
};

/************Sreeparna Start************ */
export const funcFetchCityByPinData = (pin) => async (dispatch) => {
  dispatch({
    type: types.LOADING_VIEW_STATE,
    value:true
  }); 
 var response = await MasterData.funcGetCityByPinList(pin);
if (response && response.data) {
    const statusCode = response.data.statusCode;
   
    if (statusCode === "000") {
      dispatch({
        type: types.GET_CITY_DATA_BY_PIN,
        payload: response.data.data,
      });
      dispatch({
        type: types.LOADING_VIEW_STATE,
        value:false
      });
    }
    else {
      dispatch({
        type: types.SAVE_VAL_ERROR_MS,
        payload: statusCode,
      });
      dispatch({
        type: types.LOADING_VIEW_STATE,
        value:false
      });
    //  payload = null;
      // errorState = {
      //   errorCode: "10002",
      //   errorMsg: "Invalid state",
      //   //invalidOtpAttemptCount: response.data.data?.invalidOtpAttemptCount,
      // };
    }
  }
  dispatch(funcUpdateAppStateAfterResponse(payload, errorState));
  return response?.data?.statusCode;
}

export const funcFetchCityData = (cardTypeData) => async (dispatch) => {
  var response;
  if(window.isPouchDBAvailable){
  var res = await Dbfunctions.GetState(types.LOCAL_CITY_SET);
  if (res._rev) {
    response = res?.response;
  }
  else if(res.error) {
    await fetch(window.global.config?.CityListEnc)
    .then((r) => r.text())
    .then(text  => {
      response =  JSON.parse(EncrDecrService.get(text));
      if(response?.statusCode === "000" && response.data?.eapplyMasterDataRsType?.cityList?.length > 0 && window.isPouchDBAvailable)
      Dbfunctions.CreateState({
        _id: types.LOCAL_CITY_SET, response })
    })
  } 
  } else {
    await fetch(window.global.config?.CityListEnc)
    .then((r) => r.text())
    .then(text  => {
      response =  JSON.parse(EncrDecrService.get(text));
      if(response?.statusCode === "000" && response.data?.eapplyMasterDataRsType?.cityList?.length > 0 && window.isPouchDBAvailable)
      Dbfunctions.CreateState({
        _id: types.LOCAL_CITY_SET, response })
    })    
  }

  // if (response && response.data) {
  //   if (response.data.statusCode === "000") {
  //     dispatch({
  //       type: types.GET_CITY_DATA,
  //       payload: response.data.data,
  //     });
  //   } else {
  //     dispatch({
  //       type: types.GET_CITY_DATA,
  //       payload: response?.data?.data,
  //     });
  //   }
  // } else {
  //   dispatch({
  //     type: types.GET_CITY_DATA,
  //     payload: response?.data?.data,
  //   });
  // }
  dispatch({
    type: types.GET_CITY_DATA,
    payload: response.data,
  });
  dispatch(funcUpdateAppStateAfterResponse(payload, errorState));
  return response?.statusCode;
};

// export const funcFetchBankListData = (cardTypeData) => async (dispatch) => {
//   dispatch({
//     type: types.LOADING_VIEW_STATE,
//     value: true,
//   });
//   const response = await MasterData.funcGetBankList(cardTypeData);

//   if (response && response.data) {
//     dispatch({
//       type: types.GET_BANK_LIST_DATA,
//       payload: response.data.data,
//     });
//     payload = {
//       ...initState,
//       isSubmited: true,
//       isSubmitedSuccess: true,
//       loading: false,
//     };
//     errorState = null;
//   } else {
//     payload = {
//       ...initState,
//       isSubmited: true,
//       isSubmitedSuccess: false,
//       loading: false,
//     };
//     errorState = {
//       errorCode: response.data.statusCode,
//       errorMsg: response.data.message,
//     };
//   }
//   dispatch(funcUpdateAppStateAfterResponse(payload, errorState));
// };

export const funcFetchBankListData = (cardTypeData) => async (dispatch) => {
  var response;
  var res;
  if(window.isPouchDBAvailable){
  res = await Dbfunctions.GetState(types.LOCAL_BANK_SET);
  if (res._rev) {
    response = res?.response;
  }
  else if(res.error) {
     await fetch(window.global.config?.BankListEnc)
    .then((r) => r.text())
    .then(text  => {
     response = JSON.parse(EncrDecrService.get(text));
      if(response?.statusCode === "000" && response.data?.eapplyMasterDataRsType?.bankListResponse?.bankList?.length > 0 && window.isPouchDBAvailable)
      Dbfunctions.CreateState({
      _id: types.LOCAL_BANK_SET,
      response,
      });
   })  
  } 
}
  else {
    await fetch(window.global.config?.BankListEnc)
    .then((r) => r.text())
    .then(text  => {
     response = JSON.parse(EncrDecrService.get(text));
      if(response?.statusCode === "000" && response.data?.eapplyMasterDataRsType?.bankListResponse?.bankList?.length > 0 && window.isPouchDBAvailable)
      Dbfunctions.CreateState({
      _id: types.LOCAL_BANK_SET,
      response,
      });
    })  
  }

  // if (response && response.data) {
  //   if (response.data.statusCode === "000") {
  //     dispatch({
  //       type: types.GET_BANK_LIST_DATA,
  //       payload: response.data.data,
  //     });
  //   } else {
  //     dispatch({
  //       type: types.GET_BANK_LIST_DATA,
  //       payload: response?.data?.data,
  //     });
  //   }
  // } else {
  //   dispatch({
  //     type: types.GET_BANK_LIST_DATA,
  //     payload: response?.data?.data,
  //   });
  // }
  dispatch({
    type: types.GET_BANK_LIST_DATA,
    payload: response.data,
  });
  dispatch(funcUpdateAppStateAfterResponse(payload, errorState));
  return response?.statusCode;
};

export const funcFetchIFSCCode = (value, cardListDetails) => async (
  dispatch
) => {
  dispatch({
    type: types.LOADING_VIEW_STATE,
    value: true,
  });
  const response = await MasterData.funcGetIFSCCodeList(value, cardListDetails);

  if (response && response.data) {
    let dataset = [];
    if (response.data.statusCode === "000") {
      dataset = response.data.data;
      payload = {
        ...initState,
        isSubmited: true,
        isUserRetrieve: true,
        loading: false,
      };
      errorState = null;
    } else {
      payload = {
        ...initState,
        isSubmited: true,
        loading: false,
        applicationBootFailed: true,
      };
      errorState = {
        errorCode: response.data.statusCode,
        errorMsg: response.data.message,
      };
    }
    dispatch({
      type: types.GET_IFSC_CODE_DATA,
      payload: dataset,
    });
  } else {
    payload = {
      ...initState,
      isSubmited: true,
      loading: false,
      applicationBootFailed: true,
      error: response.data?.message,
    };
  }

  dispatch(funcUpdateAppStateAfterResponse(payload, errorState));
};
export const getProductData = () => async (dispatch) => {
  // try {
     var response;
    //  let payload = { action:"submit",type:"products"}
    //  const responseServ = await CardDetails.funcFetchProductData(payload);
    //  response = JSON.parse(JSON.stringify(responseServ));
    await fetch(window.global.config?.GetProductMasterDataEnc)
      .then((r) => r.text())
      .then(text => {
        response = JSON.parse(text);
      })
     if (response && response.data) {
       const statusCode = response.statusCode;
       if (statusCode === "000") {
         dispatch({
           type: types.SAVE_NW_DATA,
           payload: response.data,
         });
         payload = {
           ...initState,
           currentAction:"NwDataSaved",
           isSubmited: false,
           isSubmitedSuccess: false,
           //screenName: screenName,
           loading: false,
         };
         errorState = null;
       } else {
         //if (statusCode === "900" || statusCode === "999") {
         payload = {
           ...initState,
           currentAction: "GetNetworkFail",
           //screenName,
           isSubmited: false,
           isSubmitedSuccess: false,
           dataFilled: false,
           loading: false,
         };
         errorState = {
           errorCode: response.statusCode,
           errorMsg: response.message,
         };
       }
     }
   // dispatch({
   //   type: types.SAVE_NW_DATA,
   //   payload: response.data,
   // });
   dispatch(funcUpdateAppStateAfterResponse(payload, errorState));
 
     
   // } catch (err) {
   //  dispatch(setError("Error fetching card details..."));
   // }
 };
export const clearBranchList = () => async (dispatch) => {
  dispatch({
    type: types.GET_IFSC_CODE_DATA,
    payload: [],
  });
};
export const funcFetchDisabilityList = () => async (dispatch) => {
  var response;
  if(window.isPouchDBAvailable) {
  var res = await Dbfunctions.GetState(types.LOCAL_DISABILITY_LIST);
  if (res._rev) {
    response = res?.response;
  }
  else if(res.error) {
    await fetch(window.global.config?.DisabilityList)
    .then((r) => r.text())
    .then(text  => {
    response =  JSON.parse(EncrDecrService.get(text));
    //response =  JSON.parse(text);
      response?.statusCode === "000" && response.data?.length > 0 && Dbfunctions.CreateState({
        _id: types.LOCAL_DISABILITY_LIST, response })
    })
  }
  } else {
    await fetch(window.global.config?.DisabilityList)
    .then((r) => r.text())
    .then(text  => {
    response =  JSON.parse(EncrDecrService.get(text));
    //response =  JSON.parse(text);
      response?.statusCode === "000" && response.data?.length > 0 && Dbfunctions.CreateState({
        _id: types.LOCAL_DISABILITY_LIST, response })
    })    
  }

  dispatch({
    type: types.LOCAL_DISABILITY_LIST,
    payload: response.data
  });
  dispatch(funcUpdateAppStateAfterResponse(payload, errorState));
  return response?.statusCode;
};